export default "__VITE_ASSET__Bi2kkJ3i__"